<template>
  <div class="module-properties">
    <div class="form-group">
      <label>Fonte de Dados</label>
      <select v-model="config.dataSource">
        <option value="file">Arquivo</option>
        <option value="database">Banco de Dados</option>
        <option value="api">API</option>
      </select>
    </div>
    
    <div class="form-group" v-if="config.dataSource === 'file'">
      <label>Tipo de Arquivo</label>
      <select v-model="config.fileType">
        <option value="csv">CSV</option>
        <option value="json">JSON</option>
        <option value="excel">Excel</option>
        <option value="parquet">Parquet</option>
      </select>
    </div>
    
    <div class="form-group" v-if="config.dataSource === 'database'">
      <label>Tipo de Banco</label>
      <select v-model="config.dbType">
        <option value="postgres">PostgreSQL</option>
        <option value="mysql">MySQL</option>
        <option value="sqlserver">SQL Server</option>
        <option value="oracle">Oracle</option>
      </select>
    </div>
    
    <div class="form-group">
      <label>Destino</label>
      <select v-model="config.destination">
        <option value="memory">Memória</option>
        <option value="temp_table">Tabela Temporária</option>
        <option value="permanent_table">Tabela Permanente</option>
      </select>
    </div>
  </div>
</template>

<script>
export default {
  name: 'UploadModuleProperties',
  props: {
    module: {
      type: Object,
      required: true
    }
  },
  data() {
    return {
      config: {
        dataSource: 'file',
        fileType: 'csv',
        dbType: 'postgres',
        destination: 'memory',
        ...this.module.config
      }
    };
  },
  watch: {
    config: {
      handler(newConfig) {
        this.$emit('update:config', newConfig);
      },
      deep: true
    }
  }
};
</script>

<style scoped>
.module-properties {
  padding: 10px;
}
.form-group {
  margin-bottom: 15px;
}
label {
  display: block;
  margin-bottom: 5px;
  font-weight: 500;
}
select, input {
  width: 100%;
  padding: 8px;
  border: 1px solid #ddd;
  border-radius: 4px;
}
</style>
